import { useEffect, useState } from 'react';
import { navItems } from '@/mocks/heiliao';

interface SiteHeaderProps {
  activeId: string;
}

export default function SiteHeader({ activeId }: SiteHeaderProps) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 240);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="w-full">
      <div className="w-full bg-foreground-950 text-background-100">
        <div className="mx-auto flex h-9 max-w-[1400px] items-center justify-between px-4 md:px-8">
          <p className="flex items-center gap-2 text-[11px] tracking-wide text-background-300">
            <i className="ri-calendar-line text-[13px]"></i>
            <span>2026年9月12日 星期六 · 目录每日复核</span>
          </p>
          <div className="hidden items-center gap-5 text-[11px] tracking-wide text-background-300 sm:flex">
            <span className="flex items-center gap-1.5">
              <i className="ri-fire-line text-primary-400"></i>
              实时热度榜已更新
            </span>
            <a href="#subscribe" className="transition-colors hover:text-accent-400">
              订阅速递
            </a>
          </div>
        </div>
      </div>

      <div className="w-full border-b border-background-300 bg-background-100">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-4 px-4 py-5 md:flex-row md:items-end md:justify-between md:px-8 md:py-7">
          <div className="flex items-center gap-4">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-md bg-primary-500 md:h-16 md:w-16">
              <span className="font-heading text-2xl font-black text-background-50 md:text-3xl">44</span>
            </div>
            <div>
              <div className="flex items-baseline gap-3">
                <span className="font-heading text-3xl font-black leading-none tracking-tight text-foreground-950 md:text-[42px]">
                  黑料区
                </span>
                <span className="rounded-sm border border-primary-300 bg-primary-50 px-2 py-0.5 text-[11px] font-medium tracking-wider text-primary-700">
                  目录站
                </span>
              </div>
              <p className="mt-1.5 text-xs tracking-wide text-foreground-600 md:text-sm">
                娱乐舆论话题 · 结构化分类目录与标签导航
              </p>
            </div>
          </div>

          <p className="hidden max-w-sm border-l-2 border-accent-500 pl-4 text-xs leading-relaxed text-foreground-600 lg:block">
            按明星、网红、政商、社会等标签分区整理，
            <br />
            用清晰目录替代杂乱信息流，按分类高效查找。
          </p>
        </div>
      </div>

      <nav
        className={`sticky top-0 z-40 w-full border-b border-background-300 transition-colors ${
          scrolled ? 'bg-background-50/95 backdrop-blur' : 'bg-background-50'
        }`}
        aria-label="站内分区导航"
      >
        <div className="mx-auto flex h-14 max-w-[1400px] items-center justify-between px-4 md:px-8">
          <ul className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => {
              const isActive = activeId === item.id;
              return (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className={`relative block whitespace-nowrap rounded-md px-3.5 py-2 text-sm transition-colors ${
                      isActive
                        ? 'font-semibold text-primary-600'
                        : 'text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
                    }`}
                  >
                    {item.label}
                    {isActive && (
                      <span className="absolute inset-x-3.5 -bottom-[7px] h-[3px] rounded-full bg-primary-500"></span>
                    )}
                  </a>
                </li>
              );
            })}
          </ul>

          <div className="flex w-full items-center justify-between lg:hidden">
            <span className="font-heading text-lg font-black text-foreground-950">44黑料区</span>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-expanded={open}
              aria-label="展开导航菜单"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-200"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>

          <a
            href="#subscribe"
            className="hidden shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 lg:flex"
          >
            <i className="ri-mail-send-line"></i>
            订阅黑料速递
          </a>
        </div>

        {open && (
          <div className="border-t border-background-300 bg-background-50 lg:hidden">
            <ul className="mx-auto grid max-w-[1400px] grid-cols-2 gap-1 px-4 py-3">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={() => setOpen(false)}
                    className={`block rounded-md px-3 py-2.5 text-sm ${
                      activeId === item.id
                        ? 'bg-primary-50 font-semibold text-primary-700'
                        : 'text-foreground-700 hover:bg-background-200'
                    }`}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
              <li className="col-span-2 mt-1">
                <a
                  href="#subscribe"
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-center gap-2 rounded-md bg-primary-500 px-3 py-2.5 text-sm font-medium text-background-50"
                >
                  <i className="ri-mail-send-line"></i>
                  订阅黑料速递
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
}